// extracted by mini-css-extract-plugin
export default {"page":"PlasticMoulding_page__-mGDS"};